import { useEffect } from "react";
import { useNavigate } from "react-router";
export const LocationMaster = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.origin == process.env.REACT_APP_LOCATION_MASTER_URL) {
        return;
      }
      const data = event.data;
      if (data.type === "INFO") {
        navigate(`/dashboard`);
      }
    });
  }, [navigate]);
  return (
    <div className="w-100% h-[100vh]">
      <iframe
        src={process.env.REACT_APP_LOCATION_MASTER_URL}
        width="100%"
        height="100%"
        title="Embedded Web App"
      ></iframe>{" "}
    </div>
  );
};
